const servicesData = [
    {
        heading : "Product Engineering",
        paragraph :"Transform ideas into powerful, scalable products."
    },
    {
        heading : "Enterprise Web Solutions",
        paragraph: "Crafting web solutions that resonate with your business goals."
    },
    {
        heading : "QA Services",
        paragraph: "Ensuring your software stands the test of perfection."
    },
    // {
    //     heading : "Staff Augumentation",
    //     paragraph: "Ensuring your software stands the test of perfection."
    // },
    {
        heading : "OutSourcing",
        paragraph: "Ensuring your software stands the test of perfection."
    }
];

export default servicesData;